module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/flow_04-d5ee19db46ab7319856bf60ef3efdd83.png";